export default {
  "login": "nfragiskatos",
  "id": 38383279,
  "node_id": "MDQ6VXNlcjM4MzgzMjc5",
  "avatar_url": "https://avatars.githubusercontent.com/u/38383279?v=4",
  "gravatar_id": "",
  "url": "https://api.github.com/users/nfragiskatos",
  "html_url": "https://github.com/nfragiskatos",
  "followers_url": "https://api.github.com/users/nfragiskatos/followers",
  "following_url": "https://api.github.com/users/nfragiskatos/following{/other_user}",
  "gists_url": "https://api.github.com/users/nfragiskatos/gists{/gist_id}",
  "starred_url": "https://api.github.com/users/nfragiskatos/starred{/owner}{/repo}",
  "subscriptions_url": "https://api.github.com/users/nfragiskatos/subscriptions",
  "organizations_url": "https://api.github.com/users/nfragiskatos/orgs",
  "repos_url": "https://api.github.com/users/nfragiskatos/repos",
  "events_url": "https://api.github.com/users/nfragiskatos/events{/privacy}",
  "received_events_url": "https://api.github.com/users/nfragiskatos/received_events",
  "type": "User",
  "site_admin": false,
  "name": "Nicholas Fragiskatos",
  "company": null,
  "blog": "https://www.nicholasfragiskatos.dev/",
  "location": null,
  "email": null,
  "hireable": null,
  "bio": "Just keep learning.",
  "twitter_username": null,
  "public_repos": 89,
  "public_gists": 0,
  "followers": 4,
  "following": 2,
  "created_at": "2018-04-14T17:12:00Z",
  "updated_at": "2023-12-14T17:23:01Z"
};
